import React from 'react';
import { motion } from 'framer-motion';
export function Contributions() {
  return <div className="w-full bg-slate-50 min-h-screen pt-24 pb-32" data-id="element-207">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-208">
        <div className="mb-20" data-id="element-209">
          <h1 className="font-serif text-5xl md:text-6xl text-navy-900 mb-6" data-id="element-210">
            Systems Architecture & P3 Impact
          </h1>
          <div className="w-24 h-1 bg-emerald-500" data-id="element-211"></div>
          <p className="mt-8 text-xl text-slate-600 max-w-3xl" data-id="element-212">
            Transforming large-scale institutions into regional economic engines
            through strategic public-private partnerships and decentralized
            financial modeling.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-213">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="bg-white p-10 border border-slate-200 shadow-sm" data-id="element-214">
            <div className="text-emerald-500 font-bold tracking-widest uppercase mb-4 text-sm" data-id="element-215">
              Blueprint
            </div>
            <h2 className="font-serif text-3xl text-navy-900 mb-6" data-id="element-216">
              Innovate ABQ
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6" data-id="element-217">
              Architected a massive public-private partnership bridging
              corporate, civic, health, and legislative bodies. Turned the
              University of New Mexico into a central hub for regional economic
              development, creating a self-sustaining innovation district.
            </p>
            <ul className="space-y-3 text-slate-700" data-id="element-218">
              <li className="flex items-start gap-3" data-id="element-219">
                <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 mt-2.5" data-id="element-220"></div>
                <span data-id="element-221">
                  Multi-stakeholder alignment across government and private
                  sectors
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-222">
                <div className="w-1.5 h-1.5 rounded-full bg-emerald-500 mt-2.5" data-id="element-223"></div>
                <span data-id="element-224">Real estate and infrastructure capitalization</span>
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="bg-navy-900 text-white p-10 shadow-sm relative overflow-hidden" data-id="element-225">
            <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-226"></div>
            <div className="relative z-10" data-id="element-227">
              <div className="text-emerald-400 font-bold tracking-widest uppercase mb-4 text-sm" data-id="element-228">
                Financial Modeling
              </div>
              <h2 className="font-serif text-3xl mb-6" data-id="element-229">
                Responsibility-Centered Management (RCM)
              </h2>
              <p className="text-slate-300 leading-relaxed mb-6" data-id="element-230">
                Pioneered decentralized financial systems at Kent State
                University, commanding a $375M division budget. Shifted the
                paradigm from centralized control to unit-level accountability
                and revenue generation.
              </p>
              <ul className="space-y-3 text-slate-300" data-id="element-231">
                <li className="flex items-start gap-3" data-id="element-232">
                  <div className="w-1.5 h-1.5 rounded-full bg-emerald-400 mt-2.5" data-id="element-233"></div>
                  <span data-id="element-234">
                    Enterprise-wide predictive data analytics integration
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-235">
                  <div className="w-1.5 h-1.5 rounded-full bg-emerald-400 mt-2.5" data-id="element-236"></div>
                  <span data-id="element-237">
                    Incentivized academic and operational throughput
                    efficiencies
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="bg-white p-10 border border-slate-200 shadow-sm md:col-span-2" data-id="element-238">
            <div className="text-emerald-500 font-bold tracking-widest uppercase mb-4 text-sm" data-id="element-239">
              Health Systems
            </div>
            <h2 className="font-serif text-3xl text-navy-900 mb-6" data-id="element-240">
              Clinical Operations & Population Health
            </h2>
            <div className="grid md:grid-cols-2 gap-8" data-id="element-241">
              <div data-id="element-242">
                <h3 className="text-xl font-medium text-navy-800 mb-3" data-id="element-243">
                  College of Population Health Launch
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-244">
                  Spearheaded the creation of entirely new academic pillars at
                  UNM and Kent State, addressing macro-sector demands in public
                  health and creating new revenue verticals.
                </p>
              </div>
              <div data-id="element-245">
                <h3 className="text-xl font-medium text-navy-800 mb-3" data-id="element-246">
                  Enterprise Clinical Integration
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-247">
                  Designed corporate risk mitigation frameworks and integration
                  models at Shands Health Care System, bridging academic
                  research with frontline clinical delivery.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}